<template>
	<div>
		<Layout :back="'/'" class="bg-degree" :navTransparent="true">
			<template slot="header">
				<h1>Registrar venta</h1>
				<p>¡Registrá tus ventas y sumá puntos!</p>
			</template>

			<div class="main-container p-4">
				<div>
					<FormulateForm ref="form" name="sell" v-model="form" @submit="save">
						<FormulateInput class="mb-3" label="Categoría" name="category" :options="selectableCategories" type="select" @change="selectedCategory" validation="required" />

						<div class="products" v-if="products">
							<div class="item" v-for="product in products" :key="product.id">
								<Product :product="product" btnText="SELECCIONAR" @clicked="productClicked" :selected="product == form.product" :compact="true" />
							</div>
						</div>

						<div v-if="form.category && products.length == 0" class="alert alert-warning mt-3 text-center">
							No se han encontrado productos en esta categoría
						</div>

						<FormulateInput label="Foto de factura" name="invoice" type="file" accept="images" listStyle="thumb" :displayBlock="true" validation-name="Factura" validation="required" />
					</FormulateForm>
				</div>
				<!-- <div class="mt-3">
					<h2>
						<span class="label">PUNTOS POR VENTA</span><br />
						{{ selectedProduct.points }}
					</h2>
				</div> -->
			</div>
			<template slot="footer">
				<div class="w-100 p-2">
					<div class="btn btn-primary btn-lg btn-block" v-ripple @click="$formulate.submit('sell')">
						<span v-if="saving">Cargando<i class="icon-loading"></i></span>
						<span v-else>Registrar</span>
					</div>
				</div>
			</template>
		</Layout>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import formMixins from '@/mixins/formMixins'
import Layout from '@/components/layout/Layout'
import PositionCard from '@/components/PositionCard'
import Product from '@/components/Product'

export default {
	name: 'Sell',
	mixins: [formMixins],
	components: {
		Layout,
		PositionCard,
		Product,
	},
	data() {
		return {
			form: {
				category: null,
				invoice: null,
				product: null,
			},
			categories: [],
			selectableCategories: [],
			products: [],
			selectedProduct: {},
			saving: false,
			loading: true,
		}
	},

	async beforeMount() {
		this.loading = true
		await this.load()
		if (this.$route.query.product) {
			// busco el producto dentro de las categorias.
			const category = this.categories.find((c) => {
				const exists = c.products.findIndex((p) => p.id == this.$route.query.product)
				if (exists >= 0) return c
			})
			if (category) {
				this.form.category = category.id
				this.selectedCategory()
				const product = this.products.find((p) => p.id == this.$route.query.product)
				this.productClicked(product)
			}
		}
		this.loading = false
	},

	methods: {
		productClicked(product) {
			this.form.product = product
		},
		selectedCategory() {
			this.form.product = null
			const category = this.categories.find((c) => c.id == this.form.category)
			this.products = category.products.sort(function(a, b) {
				return a.order - b.order
			})
			// this.products = category.products
		},

		save() {
			if (!this.form.product) {
				this.$toast.error('Seleccione un producto')
				return null
			}
			const data = {
				products: [],
				invoice: this.form.invoice.id,
			}
			data.products.push({ qty: 1, product: this.form.product.id })
			this.saving = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($data: SellInput!) {
							sellCreate(data: $data) {
								id
							}
						}
					`,
					variables: {
						data,
					},
				})
				.then(({ data }) => {
					if (data.sellCreate && data.sellCreate.id) {
						this.$toast.success('Venta registrada correctamente')
						this.$router.push('/')
					}
					this.saving = false
				})
				.catch((error) => {
					this.parseGQLErrors(error)
					this.saving = false
				})
		},

		load() {
			return this.$apollo
				.query({
					query: gql`
						query {
							categories {
								data {
									id
									name
									slug
									products {
										id
										code
										name
										slug
										points
										image
										order
									}
								}
							}
						}
					`,
					fetchPolicy: 'no-cache',
				})
				.then(({ data }) => {
					this.selectableCategories = this.covertArrayToSelectableObject(data.categories.data)
					this.categories = data.categories.data
					this.loading = false
				})
		},
	},
}
</script>

<style scoped>
h1 {
	font-size: 22pt;
}
h2 {
	font-weight: 600;
	line-height: 26px;
}
.label {
	color: #333;
}

.main-container {
	background-color: #fff;
	border-radius: 24px 0px 0px 0px;
}

.products {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}
.products .item {
	width: 100%;
}
.products .item /deep/ .product {
	border-radius: 4px;
}

@media (min-width: 380px) {
	.products .item {
		width: calc(50% - 4px);
	}
}
</style>
